/*
 * @Author: huangyan
 * @Date: 2021-08-09 10:18:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-07 10:16:53
 * @Description:
 */
import Cookies from 'js-cookie'
import { fetchVipTipsGet } from '@/api/common'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  rightPlate: 0,
  vipTips: {} // vip文案配置
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  CART_MOVE(state, num) {
    state.rightPlate = num
  },
  SET_VIPTIPS(state, tips) {
	state.vipTips = tips
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  getVipTips({ commit }) {
	fetchVipTipsGet().then(res => {
		commit('SET_VIPTIPS', res.data)
	})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
